import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Paper, MenuItem, Select, FormControl, Chip, IconButton, ArrowBackIosIcon, Button } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';


import { S_Title } from '~/components/SearchItem';
import { EAA_Item, EAA_ItemContainer, EAA_Select, EAA_Row, EAA_TitleText, EAA_Date, EAA_Input, EAA_ErrorText, EAA_Memo, EAA_Add_Btn, EAA_Btn } from '~/components/EditAndAddItem';
import LoadingOverlay from '~/components/LoadingOverlay';
import SearchBar from '~/components/SearchBar';
import CustomItemPropSelect from '~/containers/Page_Gis/Page_Info/Page_GisPier/CustomItemPropSelect';
import Actions_Wind_V2 from '~/Actions_Wind_V2';
import WindInfoTableView from './WindInfoTableView';

const styles = (theme) => ({
    card: {
        border: 'solid 1px #aaaaaa',
        borderRadius: 10,
        margin: theme.spacing(2),
        padding: theme.spacing(2),
    },
    cardContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
    },
    headerGrid: {
        borderRight: '1px solid #999999',
        minHeight: '55px',
    },
    itemContainer: {
        textAlign: 'left',
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    contentArea: {
        textAlign: 'left',
    },
    formControl: {
        width: '100%',
    },
    itemSelect: {
        borderRadius: 14,
        width: '90%',
        height: 46,
        backgroundColor: 'white',
        textAlign: 'start',
        paddingLeft: 12,
        border: '1px solid #777777',
        cursor: 'pointer',
    },
    addBtn: {
        margin: 10,
        width: 100,
    },
});

const titleText = '指定欄位報表檢索';
const titleWidth = 180;

const Page_WindInfo = (props) => {
    const { t, classes, getBaseData, windcontracts, contractFields } = props;

    const [isLoading, setLoading] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [availableItems, setAvailableItems] = useState([]);
    const [selectedFields, setSelectedFields] = useState([]);
    const [availableFields, setAvailableFields] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const [searchData, setSearchData] = useState([]);

    useEffect(() => {
        getBaseData();
    }, []);

    useEffect(() => {
        if (windcontracts) {
            const contracts = windcontracts.map((c, idx) => ({ ...c, name: c.windfield_simplename, value: c.id, order: idx + 1 }));
            setAvailableItems(contracts);
        }
    }, [windcontracts]);

    useEffect(() => {
        if (contractFields) {
            const fields = contractFields.map((f, idx) => ({ ...f, name: `${f.field_name}(${f.field_code})`, value: f.field_code, order: idx + 1 }));
            setAvailableFields(fields);
        }
    }, [contractFields]);

    const handleChangeItemSelection = (e) => {
        setSelectedItems(e.target.value);
    };

    const handleDeleteItem = (item) => {
        const updatedSelectedItems = selectedItems.filter((selectedItem) => selectedItem.value !== item.value);
        setSelectedItems(updatedSelectedItems);
    };

    const handleChangeFieldSelection = (e) => {
        setSelectedFields(e.target.value);
    };

    const handleDeleteField = (field) => {
        const updatedSelectedFields = selectedFields.filter((f) => f.value !== field.value);
        setSelectedFields(updatedSelectedFields);
    };

    const handleSearch = () => {
        if (selectedFields.length > 0 && selectedItems.length > 0) {
            setDisabled(true);
            setLoading(true);
            console.log(selectedFields);
            Actions_Wind_V2.Gis.getAdministrativeContracts({
                field_codes: selectedFields.map(f => f.value),
                windcontract_ids: selectedItems.map(w => w.value)
            }).then(res => {
                console.log(res);
                setSearchData(res);
            }).finally(() => {
                setLoading(false);
            });

        }
    };

    const handleClear = () => {
        setDisabled(false);
        setSelectedFields([]);
        setSelectedItems([]);
        setSearchData([]);
    };

    return (
        <>
            {isLoading && <LoadingOverlay loading={isLoading} />}
            <div style={{
                position: 'absolute',
                left: 13,
                right: 0,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'start',
                overflow: 'auto',
            }}>
                <SearchBar style={{ marginTop: 8 }} text={titleText} defaultOpen>
                    <Grid container spacing={1} className={classes.cardContainer}>
                        <Grid item xs={8}></Grid>
                        <Grid item xs={1}>
                            {
                                disabled &&
                                <Button variant="contained" onClick={handleClear} > 清除條件 (Clear) </Button>                    
                            }
                        </Grid>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={1}>
                            <Button variant="contained" onClick={handleSearch} style={{ backgroundColor: '#5597B4', color: '#f0f0f0' }} disabled={!(selectedFields.length > 0 && selectedItems.length > 0 )} >
                                查詢 (Search)
                            </Button>
                        </Grid>
                    </Grid>
                    <Paper elevation={0} className={classes.card}>
                        <Grid container spacing={1} className={classes.cardContainer}>
                            <Grid item className={classes.headerGrid} xs={3}>
                                <CustomItemPropSelect
                                    style={{ border: '1px solid #999999' }}
                                    label="使用風場 (Wind Contracts)"
                                    value={selectedItems}
                                    onChange={handleChangeItemSelection}
                                    options={availableItems}
                                    selectedItems={selectedItems}
                                    type="windContracts"
                                    disabled={disabled}
                                />

                            </Grid>
                            <Grid item xs={8}>
                                <div className={classes.itemContainer}>
                                    {selectedItems.map((item, idx) => (
                                        <Chip
                                            key={item.value}
                                            label={item.name}
                                            onDelete={!disabled ? () => handleDeleteItem(item): () => {}}
                                            deleteIcon={disabled ? <CheckCircleIcon />: undefined}
                                            color="secondary"
                                            variant="outlined"
                                        />
                                    ))}
                                </div>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper elevation={0} className={classes.card}>
                        <Grid container spacing={1} className={classes.cardContainer}>
                            <Grid item className={classes.headerGrid} xs={3}>
                                <CustomItemPropSelect
                                    style={{ border: '1px solid #999999' }}
                                    label="查詢欄位名稱 (Fields)"
                                    value={selectedFields}
                                    onChange={handleChangeFieldSelection}
                                    options={availableFields}
                                    selectedItems={selectedFields}
                                    type="contractFields"
                                    disabled={disabled}
                                />
                            </Grid>
                            <Grid item xs={8}>
                                <div className={classes.itemContainer}>
                                    {selectedFields.map((field, idx) => (
                                        <Chip
                                            key={field.value}
                                            label={field.name}
                                            onDelete={!disabled ? () => handleDeleteField(field): () => {}}
                                            deleteIcon={disabled ? <CheckCircleIcon />: undefined}
                                            color="secondary"
                                            variant="outlined"
                                        />
                                    ))}
                                </div>
                            </Grid>
                        </Grid>
                    </Paper>
                </SearchBar>

                <SearchBar style={{ marginTop: 8 }} text={titleText} defaultOpen>
                    <Paper style={{ minHeight: 388, overflow: 'auto' }} variant="outlined">
                        {searchData.length > 0 && <WindInfoTableView fields={selectedFields} list={searchData} />}
                    </Paper>
                </SearchBar>
            </div>
        </>
    );
};

const mapStateToProps = state => ({
    windcontracts: state.data.WindcontractsV2,
    contractFields: state.data.AdministrativeContractFieldNames,
});

const mapDispatchToProps = dispatch => ({
    getBaseData: () => {
        Actions_Wind_V2.Gis.getWindcontractsV2(dispatch);
        Actions_Wind_V2.Gis.getAdministrativeContractFieldNames(dispatch);
    },
});

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(Page_WindInfo);
